module.exports = __webpack_public_path__ + "static/img/amd8.cee9de9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/amd8.png
// module id = 51Wu
// module chunks = 1